import { apiMap, settings } from '../../../config/constants';
import { apiFetch } from '../../../apiClient';
import { getSessionDatas } from '../../../utils';
import { showLoaing } from '../../App/state/action';
export const GET_ACCOUNT_MESSAGE = 'GET_ACCOUNT_MESSAGE';

export const getAccountMessage = (data) =>({
    type: GET_ACCOUNT_MESSAGE,
    data
});

export const saveQuestionsForm = (section) => (dispatch) => {
    dispatch(showLoaing(true));
    const { applicationId } = getSessionDatas();
    const updateBusinessParams = {
        hostname: settings.hostBusiness,
        paramsObj: {
            businessInfo: {
                appId: applicationId,
                ...section
            }
        },
        method: settings.put,
    };
    return apiFetch(apiMap.updateBusiness, updateBusinessParams)(dispatch)
                .then(res => {
                    dispatch(showLoaing(false));
                    return res;
                })
                .catch(error => {
                    dispatch(showLoaing(false));
                    throw error;
                })
 }


// WEBPACK FOOTER //
// ./src/views/AccountQuestion/state/action.js